import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import {
  deleteBillingAddressRequest,
  fetchBillingAddressesRequest,
  resetBillingAddressState,
} from "../../redux/BillingAddress/BillingAddressAction";
import "../../styles/AddressForm.css";
import { CUSTOMER_ADD_BILLING_ADDRESS } from "../../component/common/Routes/CustomerRoutes";
import Loading from "../../component/ui/Loading";

export default function AddressForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const {
    addresses = [],
    loading: viewListLoading,
    error,
    success,
    deleteLoading,
  } = useSelector((state) => state.billingAddress);

  const user = useSelector((state) => state.auth.user);


  const deleteMessage = useSelector((state) => state?.billingAddress?.success);
  useEffect(() => {
    if (deleteMessage) {
      toast.success("Billing Address Deleted Successfully", {
        position: "top-center",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: false,
        onClose: () => {
          dispatch(resetBillingAddressState());
          dispatch(fetchBillingAddressesRequest(user.customer_id));
        },
      });
    }
  }, [deleteMessage]);
  useEffect(() => {
    dispatch(resetBillingAddressState());
    dispatch(fetchBillingAddressesRequest(user.customer_id));
  }, [dispatch, user?.customer_id]);

  const handleDeleteClick = (address) => {
    setSelectedAddress(address);
    setOpenDialog(true);
  };

  const handleConfirmDelete = () => {
    if (selectedAddress) {
      dispatch(deleteBillingAddressRequest(selectedAddress.id));
    }
    setOpenDialog(false);
  };

  if (viewListLoading) {
    return <Loading text="Loading Address details..." />;
  }
  return (
    <>
      <ToastContainer />
      <Box className="container">
        <Box mb={3} className="header">
          <Button
            variant="contained"
            className="add-button"
            onClick={() => navigate(CUSTOMER_ADD_BILLING_ADDRESS)}
          >
            Add Address
          </Button>
        </Box>

        {!addresses || addresses.length === 0 ? (
          <Box textAlign="center" mt={4}>
            <Typography variant="h6">No addresses found.</Typography>
          </Box>
        ) : (
          <Grid container spacing={3}>
            {addresses.map((address) => (
              <Grid item xs={12} sm={6} key={address.id}>
                <Card className="address-card">
                  <CardContent>
                    <Typography variant="h6" className="address-name">
                      {address.first_name} {address.last_name}
                    </Typography>
                    <Typography variant="body1" className="address-details">
                      {address.address1}, {address.address2},{" "}
                      {address.country_name}, {address.state_name},{" "}
                      {address.city_name}- {address.pincode}
                    </Typography>
                    <Typography variant="body2" className="mobile-info">
                      Mobile: {address.phone_number}
                    </Typography>

                    <Box className="card-footer">
                      <Box className="button-container">
                        <Button
                          variant="contained"
                          className="orange-button"
                          onClick={() =>
                            navigate(`/customer/address/edit/${address.id}`)
                          }
                        >
                          Edit
                        </Button>

                        <Button
                          variant="contained"
                          className="grey-button"
                          onClick={() => handleDeleteClick(address)}
                        >
                          Delete
                        </Button>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            Are you sure you want to delete the address:{" "}
            <strong>
              {selectedAddress?.first_name} {selectedAddress?.last_name}
            </strong>
            ?
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenDialog(false)}
              className="grey-button"
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmDelete}
              variant="contained"
              className="orange-button"
              loading={deleteLoading}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
}
